import { render } from "./MentionedMessage.vue?vue&type=template&id=f411409e"
import script from "./MentionedMessage.vue?vue&type=script&lang=js"
export * from "./MentionedMessage.vue?vue&type=script&lang=js"

import "./MentionedMessage.vue?vue&type=style&index=0&id=f411409e&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/facilitabots.interagev2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__